/**
 * Colours of indicator lines (po-chart-visual-spec.md §7.3): the 11 colours
 * of PO in its order. The values are Sass variables passed to the engine as
 * CSS custom properties `--chart-palette-<name>` (E13), see theme.js.
 */
export const PALETTE = {
  LIME: "lime",
  AQUA: "aqua",
  YELLOW: "yellow",
  ORANGE: "orange",
  RED: "red",
  PUMPKIN: "pumpkin",
  BLUE: "blue",
  MAGENTA: "magenta",
  SILVER: "silver",
  WHITE: "white",
  BLACK: "black",
};

export const PALETTE_NAMES = Object.values(PALETTE);

/**
 * @param {string} name - PALETTE value
 * @returns {string} CSS custom property with the colour
 */
export const paletteProperty = (name) => `--chart-palette-${name}`;
